module.exports = __webpack_public_path__ + "img/mood_sleep.2d9c9f16.png";